import PackageXIcon from "@redotech/redo-icons/package-x.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const FulfillmentMixedStatuses = memo(function FulfillmentMixedStatuses({
  deselectComplete,
  onExportPickListCsv,
  onPrintPackingSlip,
  onPrintPickList,
  onPrintOrderSummary,
}: {
  deselectComplete: () => void;
  onExportPickListCsv: () => void;
  onPrintPackingSlip: () => void;
  onPrintPickList: () => void;
  onPrintOrderSummary: () => void;
}) {
  return (
    <Flex
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: "hidden",
      }}
    >
      <Flex align="center" justify="center" p="4xl">
        <Flex
          bgColor="primary"
          borderRadius="lg"
          dir="column"
          gap="2xl"
          p="2xl"
          style={{ opacity: 1 }}
        >
          <Flex dir="row">
            <PackageXIcon />
            <Text fontSize="md" textColor="primary">
              Cannot complete fulfillments
            </Text>
          </Flex>
          <Flex dir="column">
            <Text fontSize="sm" textColor="primary">
              You have selected some fulfillments that are not ready to be
              completed or have already been completed. To continue, you will
              need to deselect those fulfillments.
            </Text>
            <Flex dir="column" gap="md" p="md">
              <RedoButton
                hierarchy="secondary"
                onClick={onPrintPackingSlip}
                size="sm"
                text="Print packing slips"
              />
              <RedoButton
                hierarchy="secondary"
                onClick={onPrintPickList}
                size="sm"
                text="Print pick lists"
              />
              <RedoButton
                hierarchy="secondary"
                onClick={onPrintOrderSummary}
                size="sm"
                text="Print order summaries"
              />
              <RedoButton
                hierarchy="secondary"
                onClick={onExportPickListCsv}
                size="sm"
                text="Export pick list CSV"
              />
              <RedoButton
                hierarchy="tertiary"
                onClick={deselectComplete}
                size="sm"
                text="Deselect fulfilled orders"
              />
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
});
